module.exports = __webpack_public_path__ + "static/media/wallet-icon-active.3723e66d.svg";